// extracted by mini-css-extract-plugin
module.exports = {"block":"Message_block__L55IB","text":"Message_text__xd8Tk"};